import { IconKeys } from '@components/icon';

const NavList = [

  {
    id: 'consent-preferences',
    icon: IconKeys.CheckSquare,
    labelKey: 'CONSENT_PREFERENCES_LABEL',
    link: 'consent-preferences',
    children: [],
  },
  {
    id: 'requests',
    icon: IconKeys.FileText,
    labelKey: 'REQUESTS_LABEL',
    link: 'requests',
    children: [],
  },
  {
    id: 'notification-settings',
    icon: IconKeys.Bell,
    labelKey: 'NOTIFICATION_SETTINGS_LABEL',
    link: 'notification-settings',
    children: [],
  },
];

export default NavList;
